import { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

function parseTokenPayload(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return {};
  }
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!localStorage.getItem('auth_token')
  );
  const [isAdmin, setIsAdmin] = useState(() => {
    const token = localStorage.getItem('auth_token');
    return token ? parseTokenPayload(token).admin === true : false;
  });
  const [currentUserId, setCurrentUserId] = useState(() => {
    const token = localStorage.getItem('auth_token');
    return token ? parseTokenPayload(token).user_id ?? null : null;
  });

  const login = (token) => {
    localStorage.setItem('auth_token', token);
    const payload = parseTokenPayload(token);
    setIsAuthenticated(true);
    setIsAdmin(payload.admin === true);
    setCurrentUserId(payload.user_id ?? null);
  };

  const logout = () => {
    localStorage.removeItem('auth_token');
    setIsAuthenticated(false);
    setIsAdmin(false);
    setCurrentUserId(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isAdmin, currentUserId, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    return {
      isAuthenticated: false,
      isAdmin: false,
      currentUserId: null,
      login: () => {},
      logout: () => {}
    };
  }
  return context;
}
